import { QueryTuple, useLazyQuery } from '@apollo/client';
import { GET_DRAWING_LIST } from '@bechtel/client-gql';
import { PagingInput, CommodityFilterInput, CommodityList } from '@bechtel/types';

export function useDrawingListQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ commodities: CommodityList; input: CommodityFilterInput; paging: PagingInput }, Record<string, any>> {
  const response = useLazyQuery<{
    commodities: CommodityList;
    input: CommodityFilterInput;
    paging: PagingInput;
  }>(
    GET_DRAWING_LIST,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
